import React from "react";

const Tag = ({ getTag }) => {
  return <div className="tagComp">{getTag}</div>;
};

export default Tag;
